export default __webpack_public_path__ + "static/media/search-solid.cc51b702.svg";